import { useAuthStore } from 'processes/auth/model/state';
import { FunctionComponent } from 'react';
import { AdminPersonalAccount, UsersPersonalAccount } from 'widgets/PersonalAccount/rolesUI';

export const PersonalAccount: FunctionComponent = () => {
	const { isAdmin } = useAuthStore();

	if (isAdmin) {
		return <AdminPersonalAccount />;
	}

	return <UsersPersonalAccount />;
};
